import { render, staticRenderFns } from "./securityTemplate.vue?vue&type=template&id=39bd0274"
import script from "./securityTemplate.vue?vue&type=script&lang=js"
export * from "./securityTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports